// extracted by mini-css-extract-plugin
export default {"header":"RootLayoutHeader_header__yWGWB"};